const prefix = "USER_";

export const CHANGE_PASSWORD_FAILED = prefix + "CHANGE_PASSWORD_FAILED";
export const CHANGE_PASSWORD_STARTED = prefix + "CHANGE_PASSWORD_STARTED";
export const CHANGE_PASSWORD_SUCCEEDED = prefix + "CHANGE_PASSWORD_SUCCEEDED";
export const SIGN_IN_CLEAR_PASSWORD = prefix + "SIGN_IN_CLEAR_PASSWORD";
export const SIGN_IN_FAILED = prefix + "SIGN_IN_FAILED";
export const SIGN_IN_FAILED_MFA = prefix + "SIGN_IN_FAILED_MFA";
export const SIGN_IN_SET_DATA = prefix + "SIGN_IN_SET_DATA";
export const SIGN_IN_SET_REDIRECT = prefix + "SIGN_IN_SET_REDIRECT";
export const SIGN_IN_STARTED = prefix + "SIGN_IN_STARTED";
export const SIGN_IN_STARTED_REDIRECT_MFA_CHALLENGE = prefix + "SIGN_IN_STARTED_REDIRECT_MFA_CHALLENGE";
export const SIGN_IN_STARTED_MFA_CHALLENGE = prefix + "SIGN_IN_STARTED_MFA_CHALLENGE";
export const SIGN_IN_STARTED_MFA_CHALLENGE_SUCCESSFUL = prefix + "SIGN_IN_STARTED_MFA_CHALLENGE_SUCCESSFUL";

export const SIGN_IN_SUCCEEDED = prefix + "SIGN_IN_SUCCEEDED";
export const SIGN_IN_SUCCEEDED_WITH_MFA = prefix + "SIGN_IN_SUCCEEDED_WITH_MFA";
export const SIGN_OUT_FAILED = prefix + "SIGN_OUT_FAILED";
export const SIGN_OUT_SUCCEEDED = prefix + "SIGN_OUT_SUCCEEDED";
export const STATE_HIDE_ERROR = prefix + "STATE_HIDE_ERROR";
export const WIDGET_ADD = prefix + "WIDGET_ADD";
export const WIDGET_MOVE_DOWN = prefix + "WIDGET_MOVE_DOWN";
export const WIDGET_MOVE_UP = prefix + "WIDGET_MOVE_UP";
export const WIDGET_REMOVE = prefix + "WIDGET_REMOVE";
export const WIDGET_RESET = prefix + "WIDGET_RESET";
export const WIDGET_TOGGLE = prefix + "WIDGET_TOGGLE";
export const WIDGETS_GET_FAILED = prefix + "WIDGETS_GET_FAILED";
export const WIDGETS_GET_STARTED = prefix + "WIDGETS_GET_STARTED";
export const WIDGETS_GET_SUCCEEDED = prefix + "WIDGETS_GET_SUCCEEDED";
export const WIDGETS_INITIAL_SETUP = prefix + "WIDGETS_INITIAL_SETUP";
export const WIDGETS_SAVE_FAILED = prefix + "WIDGETS_SAVE_FAILED";
export const WIDGETS_SAVE_STARTED = prefix + "WIDGETS_SAVE_STARTED";
export const WIDGETS_SAVE_SUCCEEDED = prefix + "WIDGETS_SAVE_SUCCEEDED";
